module.exports = __webpack_public_path__ + "static/media/564.cebbd4ba.png";